import { render, staticRenderFns } from "./recent_sessions_table.vue?vue&type=template&id=0151a6b7&scoped=true&"
import script from "./recent_sessions_table.vue?vue&type=script&lang=ts&"
export * from "./recent_sessions_table.vue?vue&type=script&lang=ts&"
import style0 from "./recent_sessions_table.vue?vue&type=style&index=0&id=0151a6b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0151a6b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardTitle,VChip,VDataTable,VRow,VTooltip})
